import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
const isContactField = formField => formField.objectTypeId === FormFieldPropertyObjectTypesIds.CONTACT;
export default isContactField;